import React from 'react'

import { Pallet } from '../../api/models'
import { PalletLabel } from './PalletLabel'

const labelMap = {
  [Pallet.type]: PalletLabel,
}

interface Props {
  items: any[]
}

export const BulkLabels = (props: Props) => {
  const { items } = props
  return (
    <>
      {items.map((obj: any) => {
        const Label = labelMap[obj.type]
        return <Label key={obj.guid} obj={obj} />
      })}
    </>
  )
}
